import { Component, Input, OnInit } from '@angular/core';
import { InvoiceStatisticsChartCardComponent } from 'gung-dashboard';
import { CultDashboardDataService } from '../../services/cult-dashboard-data.service';
import { Subject, takeUntil } from 'rxjs';

@Component({
    selector: 'cult-cult-invoice-statistics-chart-card',
    templateUrl: './cult-invoice-statistics-chart-card.component.html',
    styleUrls: ['./cult-invoice-statistics-chart-card.component.scss'],
    standalone: false
})
export class CultInvoiceStatisticsChartCardComponent extends InvoiceStatisticsChartCardComponent implements OnInit {
  protected unsubscribe: Subject<void> = new Subject();
  @Input()
  preConditions: any;

  ngOnInit() {

  }
}
